import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.SEARCH_BY_UUID](state) {
        return (uuid) => state[uuid];
    },
    [GETTERS.CURRENT_SEARCH](state, getters) {
        return state[getters[GETTERS.CURRENT_SEARCH_UUID]];
    },
    [GETTERS.SEARCH_TAG_LIST](state, getters) {
        const search = getters[GETTERS.CURRENT_SEARCH];
        if (search) {
            return search.tag_list;
        }
        return {};
    },
    [GETTERS.SEARCH_FILTER_TAG_LIST](state, getters) {
        const search = getters[GETTERS.CURRENT_SEARCH];
        if (search) {
            return search.filter_tag_list;
        }
        return {};
    },
};
